export default __webpack_public_path__ + "static/media/bad-request.5e226429.svg";